module.exports = __webpack_public_path__ + "img/businessBg.c6335595.jpg";